// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"c7ae0006","209":"933d881f","228":"f665b639","326":"5915c21a","453":"516bce4a","527":"abfd1c02","707":"caf3ecaf","717":"c15d250c","719":"a4e20f39","744":"63994ac1","840":"c4df4798"}[chunkId] + ".chunk.js";
};